import {
  footerSocialData,
  footerSocialIconMap,
} from '$core/shell/footer/footer-social/footer-social';
import { Component, computed, inject } from '@angular/core';
import { StaticService } from '../../services/static.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  private readonly staticService = inject(StaticService);

  public readonly items = footerSocialData;
  public readonly iconMap = footerSocialIconMap;

  protected readonly menu = computed(() => this.staticService.static().footer);
}
